<template>
  <v-container v-if="projectReader.ready">
    <ProjectMainCard
      :project="project"
      :recordCache="recordCache"
      :dialogController="projectDialogController"
    />
    <RecordListContainer :project="project" />
    <ProjectEditorDialog :dialogController="projectDialogController">
    </ProjectEditorDialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import ProjectEditorDialog from "@/components/ProjectEditorDialog";
import ProjectMainCard from "@/components/ProjectMainCard";
import RecordListContainer from "./RecordListContainer";

export default {
  components: {
    ProjectMainCard,
    RecordListContainer,
    ProjectEditorDialog
  },
  computed: {
    ...mapState([
      "projectReader",
      "recordReader",
      "recordCacheReader",
      "projectDialogController"
    ]),
    project() {
      return this.projectReader.getByProjectId(this.$route.params.projectId);
    },
    recordCache() {
      return this.recordCacheReader.getByProjectId(
        this.$route.params.projectId
      );
    }
  }
};
</script>
